import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EvkMapasCacheService {
  private cache: {[index: string]:any} = {}

  constructor() {

  }

  private construirCache(){
    let storage = window.localStorage;
    let cache = storage.getItem('cache_georeferencia');
    if(cache){
      this.cache = JSON.parse(cache);
    }else{
      // storage.setItem('cache_georeferencia', '{}');
      this.cache = {};
    }
  }

  public guardarPeticionEnCache(consulta: string, respuesta: any){
    this.construirCache();
    this.cache[consulta] = respuesta;
    let cacheStr = JSON.stringify(this.cache);
    // localStorage.setItem('cache_georeferencia', cacheStr);
  }

  public buscarPeticionEnCache(consulta: string){
    this.construirCache();
    return this.cache[consulta];
  }
}
